var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRocket11(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2514_42981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1162 17.2505L10.4476 19.1683L4.81354 30.4366L15.7341 27.706L18.1162 17.2505Z",
    fill: "#7F6D67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1587 31.2773L21.7003 33.672L18.9697 44.5926L30.2379 38.9585L32.1587 31.2773Z",
    fill: "#635550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2347 33.9391C24.8936 35.4505 22.4873 35.8681 22.2882 35.9476L13.4384 27.0978C13.6373 26.6205 13.9356 24.3334 15.3874 21.0918L19.7826 21.5095L28.3142 30.0411L28.2347 33.9391Z",
    fill: "#FF3636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2347 33.9391C24.8937 35.4505 22.4873 35.8681 22.2883 35.9476L17.8733 31.5327L23.8395 25.5664L28.3142 30.0411L28.2347 33.9391Z",
    fill: "#CE2700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9938 26.3223C35.772 29.6635 31.9934 32.2487 28.2347 33.9392L15.3875 21.092C16.9189 17.6913 19.4843 13.8927 23.0839 10.4125C35.0362 -1.10244 46.5908 1.30403 48.5 0.90625C48.1221 2.79559 50.4887 14.3899 38.9938 26.3223Z",
    fill: "#EDE9E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9938 26.3223C35.772 29.6635 31.9934 32.2487 28.2347 33.9392L21.8508 27.5553L48.5 0.90625C48.1221 2.79559 50.4887 14.3899 38.9938 26.3223Z",
    fill: "#DFD7D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.774 37.3994C16.6602 38.5131 0.659094 48.8265 0.5 48.906C4.05988 42.4028 10.6741 32.5668 11.8077 31.4332C13.4584 29.7825 16.1432 29.8024 17.774 31.4332C17.8137 31.4728 17.8336 31.4928 17.8535 31.5525C19.4246 33.2033 19.3848 35.7885 17.774 37.3994Z",
    fill: "#FFE477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7607 19.6005C35.5732 21.7881 31.9933 21.7881 29.8058 19.6005C27.6182 17.413 27.6182 13.8331 29.8058 11.6456C31.9933 9.45799 35.5732 9.45799 37.7607 11.6456C39.9483 13.8331 39.9483 17.413 37.7607 19.6005Z",
    fill: "#7F6D67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.823 24.5712L28.8117 22.5825L26.823 20.5938L24.8343 22.5825L26.823 24.5712Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7439 10.6508L42.7326 8.66211L40.7439 6.67339L38.7552 8.66211L40.7439 10.6508Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7495 9.65652L40.7438 10.6509L42.7326 8.66216L41.7382 7.6678L39.7495 9.65652Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8282 23.5784L26.8226 24.5728L28.8113 22.584L27.8169 21.5897L25.8282 23.5784Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8058 19.6005L37.7608 11.6455C39.9483 13.8331 39.9483 17.4129 37.7608 19.6005C35.5732 21.788 31.9933 21.788 29.8058 19.6005Z",
    fill: "#635550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7833 18.4287C33.0276 18.4287 32.3213 18.1386 31.7945 17.6118C31.2677 17.0849 30.9775 16.3787 30.9775 15.623C30.9775 14.8673 31.2677 14.1611 31.7945 13.6343C32.3213 13.1075 33.0276 12.8174 33.7833 12.8174C34.5389 12.8174 35.2452 13.1074 35.772 13.6343C36.8685 14.7309 36.8685 16.5152 35.772 17.6119C35.2452 18.1386 34.5389 18.4287 33.7833 18.4287Z",
    fill: "#00C7CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7833 18.4287C34.5389 18.4287 35.2452 18.1387 35.772 17.6118C36.8685 16.5152 36.8685 14.731 35.772 13.6343L31.7945 17.6118C32.3214 18.1387 33.0277 18.4287 33.7833 18.4287Z",
    fill: "#00969B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.774 37.3996C16.6602 38.5133 0.659094 48.8267 0.5 48.9062L17.8535 31.5527C19.4246 33.2035 19.3848 35.7887 17.774 37.3996Z",
    fill: "#FDBF00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2514_42981"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5 0.90625)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket11);
export default __webpack_public_path__ + "static/media/rocket-1-1.0392b3def18ba7d582663e669601e312.svg";
export { ForwardRef as ReactComponent };